import React from 'react'
import styled from 'styled-components'

import type { SelectOption } from './Select'
import Select, { toSelectOption } from './Select'
import SmallPill from './SmallPill'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px 100px 1fr;
  align-items: center;
  column-gap: 20px;
`

const LeftAlignedContainer = styled.div`
  justify-self: start;
`

const RightAlignedContainer = styled.div`
  justify-self: end;
`

const SelectContainer = styled.div`
  width: 75px;
  display: inline-block;
`

type Props<T extends string> = {
  total: number
  offset: number
  limit: number
  onChangePage: (limit: number, offset: number) => void
  limitSelectOptions: SelectOption<T>[]
}

const Pagination = <T extends string>({
  total,
  offset,
  limit,
  onChangePage,
  limitSelectOptions,
}: Props<T>) => {
  const totalPages: number = Math.ceil(total / limit)

  const pageSelectOptions: SelectOption[] = Array.from(Array(totalPages).keys())
    .map(a => (a + 1).toString())
    .map(toSelectOption)

  const currentSelectedPage = offset / limit + 1

  const onSelectPage = (page: number) => {
    onChangePage(limit, limit * (page - 1))
  }

  const showPreviousPageButton = currentSelectedPage > 1

  const showNextPageButton = currentSelectedPage < totalPages

  return (
    <Container>
      <LeftAlignedContainer>
        Show page{' '}
        <SelectContainer>
          <Select
            options={pageSelectOptions}
            selectedValue={currentSelectedPage.toString()}
            onSelect={offset => onSelectPage(parseInt(offset))}
          />
        </SelectContainer>{' '}
        of {totalPages}
      </LeftAlignedContainer>
      <RightAlignedContainer>
        {showPreviousPageButton && (
          <SmallPill onClick={() => onSelectPage(currentSelectedPage - 1)}>
            {'<'} Previous
          </SmallPill>
        )}
      </RightAlignedContainer>
      <LeftAlignedContainer>
        {showNextPageButton && (
          <SmallPill onClick={() => onSelectPage(currentSelectedPage + 1)}>
            Next {'>'}
          </SmallPill>
        )}
      </LeftAlignedContainer>
      <RightAlignedContainer>
        Show{' '}
        <SelectContainer>
          <Select
            options={limitSelectOptions}
            selectedValue={limit.toString()}
            onSelect={limit => onChangePage(parseInt(limit), 0)}
          />
        </SelectContainer>{' '}
        results per page
      </RightAlignedContainer>
    </Container>
  )
}

export default Pagination
